import './OnboardingPages.scss';

import React from 'react';
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import {Formik} from "formik";
import {useNavigate} from "react-router-dom";
import * as yup from "yup";
import {FORGOT_PASSWORD_EMAIL, REGISTER_CREDENTIALS, REGISTER_EMAIL_CONFIRM} from "../../../services/PageUtils";
import {SessionService} from "../../../services/api/SessionService";
import {CredentialsService} from "../../../services/api/CredientialsService";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../../services/store/store";
import {handleEnteringRegisteringOrResetting} from "../../../services/store/reducers/session/slice";
import FormContainer from "../components/FormContainer";
import ErrorBox from "../components/ErrorBox";
import Button from "../../../components/Button";
import {useApiRequest} from '../../../hooks/useApiRequest';

interface Props {

}

const Login = ({}: Props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const {createSession} = SessionService();
    const {resendConfirmation} = CredentialsService();

    const { execute: login, loading, errMsg } = useApiRequest(createSession);
    const { execute: resend, loading: resendLoading} = useApiRequest(resendConfirmation);

    const schema = yup.object().shape({
        email: yup.string().email().required("Email address is required"),
        password: yup.string().required("Password is required"),
    });

    const submitForm = async (values: any) => {
        const resp = await login({ email: values.email, password: values.password });

        if (resp && resp.error) {
            if (resp?.error?.apiError?.code === 'E1001') {
                const resendResp = await resend({ email: values.email, password: values.password });
                if (!resendResp || resendResp.error) return;

                navigate(REGISTER_EMAIL_CONFIRM, {
                    state: {
                        email: values.email,
                        password: values.password,
                    }
                });
            }
            return;
        }
    };

    const goToForgotPassword = () => {
        dispatch(handleEnteringRegisteringOrResetting())
        navigate(FORGOT_PASSWORD_EMAIL);
    }

    const goToRegister = () => {
        dispatch(handleEnteringRegisteringOrResetting())
        navigate(REGISTER_CREDENTIALS);
    }

    return (
        <FormContainer additionalStyles={{ justifyContent: 'space-between' }}>
            <div>
                <div className={"header_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <span className={"heading"} style={{ alignSelf: 'flex-start' }}>Login</span>

                <Formik
                    validationSchema={schema}
                    onSubmit={submitForm}
                    initialValues={{
                        email: "",
                        password: "",
                    }}
                >
                    {({
                          handleSubmit,
                          handleChange,
                          handleBlur,
                          values,
                          touched,
                          isValid,
                          errors,
                      }) => (
                        <form onSubmit={handleSubmit}>
                            <h3 className={"onboarding_label"}>Email</h3>
                            <input
                                required
                                className="onboarding_input"
                                type="email"
                                name="email"
                                placeholder="Email address"
                                value={values.email}
                                onBlur={handleBlur}
                                onChange={handleChange}
                            />
                            {touched.email && errors.email && (
                                <ErrorBox text={errors.email} />
                            )}

                            <h3 className={"onboarding_label"}>Password</h3>
                            <input
                                required
                                className="onboarding_input"
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={values.password}
                                onBlur={handleBlur}
                                onChange={handleChange}
                            />
                            {touched.password && errors.password && (
                                <ErrorBox text={errors.password} />
                            )}

                            <div className={"login_forgotPasswordContainer"}>
                                <span onClick={goToForgotPassword}>
                                    Forgot your password?
                                </span>
                            </div>

                            {errMsg && <ErrorBox text={errMsg}/>}

                            <Button text="LOGIN" type="submit" disabled={loading || resendLoading} />
                        </form>
                    )}
                </Formik>
            </div>

            {/*<div className={"login_registerContainer"}>*/}
            {/*    <div className={"login_line"}/>*/}
            {/*    <span className={"login_registerTxt"}>Or, you can create a new account:</span>*/}
            {/*    <Button text={"REGISTER"} onClick={goToRegister} variant={"secondary"} />*/}
            {/*</div>*/}
        </FormContainer>
    )
}

export default Login;